import { render } from "./IMIVVitaminTherapiesContentEn.vue?vue&type=template&id=7b3ba4d4"
import script from "./IMIVVitaminTherapiesContentEn.vue?vue&type=script&lang=js"
export * from "./IMIVVitaminTherapiesContentEn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__